import { createContext } from 'react';

export const RadioInputContext = createContext<{
  selectedValue?: string | null;
  grow?: 'auto' | 'even' | 'fill';
  name?: string;
  onValue?: (value: string) => void;
}>({});
